export const formatValue = (value: unknown): string => {
  if (value === undefined || value === null) {
    return String(value);
  }

  if (typeof value === 'string') {
    try {
      // Try to parse the string as JSON. If it succeeds, stringify it back
      // with pretty printing. This handles cases where we get a JSON string
      // instead of a JSON object.
      const parsed = JSON.parse(value);
      return JSON.stringify(parsed, null, 2);
    } catch {
      // Not a JSON string, so return it as is.
      return value;
    }
  }

  if (
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    typeof value === 'bigint'
  ) {
    return value.toString();
  }

  return JSON.stringify(value, null, 2);
};
